import { render, staticRenderFns } from "./PayersIndex.vue?vue&type=template&id=a07d3b6c&scoped=true"
import script from "./PayersIndex.vue?vue&type=script&lang=js"
export * from "./PayersIndex.vue?vue&type=script&lang=js"
import style0 from "./PayersIndex.vue?vue&type=style&index=0&id=a07d3b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07d3b6c",
  null
  
)

export default component.exports